import CustomerCareLocaleKeys from '../../../locales/keys';
import { BusinessUnitSelectors, CoreLocaleKeys, i18n, SessionSelectors } from 'invision-core';
import { CUSTOMER_CATEGORY, HierarchyNodeType } from '../../createCustomerPopup/create.customer.popup.constants';
import { getCustomerSearch, routeToCustomer } from '../../../reducers/actions/search.customer.actions';
import { clearSearchResults, setSearchType } from '../../../reducers/actions/search.actions';
import { CustomerSearchCurrentPageNumberSelector, CustomerSearchArraySelector, CustomerSearchRecordCountSelector, CustomerSearchTotalPageCountSelector } from '../../../reducers/selectors/search.customer.selectors';
import { SearchTypeSelector } from '../../../reducers/selectors/search.selectors';
import { MetadataCodeLoadedSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
export function SearchCustomerResultsController($ngRedux) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      currentPageNumber: CustomerSearchCurrentPageNumberSelector(store),
      customerSearchResultCount: CustomerSearchRecordCountSelector(store),
      customerSearchResults: CustomerSearchArraySelector(store),
      isDbss: BusinessUnitSelectors.IsDbss(store),
      pageSize: SessionSelectors.PageSizePreferenceSelector(store),
      searchType: SearchTypeSelector(store),
      subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
      subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
      subscriberStatesLoaded: MetadataCodeLoadedSelector(CODES.SubscriberState, store),
      totalPageCount: CustomerSearchTotalPageCountSelector(store)
    };
  };
  this.$onInit = function () {
    _this.customerCareLocaleKeys = CustomerCareLocaleKeys;
    _this.customerCategory = CUSTOMER_CATEGORY;
    var controllerActions = {
      clearSearchResults: clearSearchResults,
      fetchCodeTypesThunk: fetchCodeTypesThunk,
      getCustomerSearch: getCustomerSearch,
      routeToCustomer: routeToCustomer,
      setSearchType: setSearchType
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    if (!_this.state.subscriberStatesLoaded) {
      _this.actions.fetchCodeTypesThunk(CODES.SubscriberState);
    }
    _this.getRecordCount = function () {
      var firstRecordNumberOnPage = _this.state.currentPageNumber * _this.state.pageSize + 1 - _this.state.pageSize;
      var lastRecordNumberOnPage = Math.min(_this.state.currentPageNumber * _this.state.pageSize, _this.state.customerSearchResultCount);
      return i18n.translate(CoreLocaleKeys.PAGING_FOOTER, {
        pageRecordFirst: firstRecordNumberOnPage,
        pageRecordLast: lastRecordNumberOnPage,
        totalRecordCount: _this.state.customerSearchResultCount
      });
    };
    _this.clearResults = function () {
      var type = _this.state.searchType;
      _this.actions.clearSearchResults();
      _this.actions.setSearchType(type);
    };
    _this.customerClicked = function (customer) {
      _this.actions.routeToCustomer(customer);
    };
    _this.pageSelected = function (pageNum) {
      _this.onPageChange()(pageNum);
      _this.actions.getCustomerSearch(_this.customerSearchModel, pageNum, _this.state.pageSize);
    };
  };
  this.getGlyph = function (customer) {
    if (_this.state.isDbss) {
      if (!!customer.HierarchyParentSubscriberId && customer.HierarchyNodeType === HierarchyNodeType.INHERITED) {
        return 'gen-hierarchy-lg';
      } else if (customer.Category === CUSTOMER_CATEGORY.COMMERCIAL) {
        return 'building';
      } else {
        return 'user';
      }
    }
    return '';
  };
  this.isServiceInheritedHierarchyNode = function (customer) {
    if (!!customer.HierarchyParentSubscriberId && customer.HierarchyNodeType === HierarchyNodeType.INHERITED) {
      return true;
    }
    return false;
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
}

// Definition for the self-contained SearchResults component
export var SearchCustomerResults = {
  template: require('./search.customer.results.html'),
  controller: SearchCustomerResultsController,
  controllerAs: 'SearchResults',
  bindings: {
    customerSearchModel: '<',
    pageNumber: '<',
    onPageChange: '&'
  }
};